import styled from 'styled-components/macro';
import {CSS_PADDING,CSS_PADDING_COMPACT,CSS_COLOR_BORDERS,CECA_COLORS,CECA_OPTIONS_POSSIBILITIES_HEIGHT_THRESHOLD, IFRAME_MODE} from '../constants';
import Scrolldown from './Scrolldown';
import Selector from './EditorSelector';
import {ralToColor} from '../helpers';
import { useState, useEffect, useRef } from "react";
import SchematicSVG from './SchematicSVG';


const EditorStyled = styled.div`
	.selectors-holder {
		padding: ${CSS_PADDING_COMPACT};
	}
	h2 {
		margin-top: 0;
		font-weight: 700;
		font-size: 26px;
		color: #555555;
		padding: ${CSS_PADDING};
		border-bottom: 1px solid ${CSS_COLOR_BORDERS};
	}
	
`;


function Editor({options,selected_values,setSelection,onActiveStep,onAsk,hideAsk}) {

	const svgs_height = 64;
	// const [setted_steps,setSettedSteps] = useState({
	// 	color_roof: true,
	// 	delivery: true,
	// 	depth: true,
	// 	height: true,
	// 	modules: true,
	// 	wall_back: true,
	// 	wall_front: true,
	// 	wall_left: true,
	// 	wall_right: true,
	// 	width0: true
	// }); great for testing
	const [setted_steps,setSettedSteps] = useState({delivery: true});
	const [active_step,setActiveStep] = useState(false);
	const container_ref = useRef();

	useEffect(()=>{
		onActiveStep(active_step);
	},[active_step,onActiveStep]);


	useEffect(()=>{
		if(container_ref.current && !IFRAME_MODE){
			container_ref.current.scrollIntoView(true);
		}
		window.scrollTo(0,0);
	},[container_ref]);


	function setSettedStep(step_id){
		if(step_id!=='ask'){
			setSettedSteps((setted_steps)=>({
				...setted_steps,
				[step_id]: true
			}));
		}else{
			onAsk();
		}
	}
	function onSelection(id,value){
		setSelection(id,value);
		setSettedStep(id);
	}

	const has_optional_accessories = !!(selected_values.optional_accessories&&selected_values.optional_accessories.enabled);
	const has_color_walls = !!(options.color_walls.length);

	const selectors = [
		{
			head: "Choisissez la profondeur de votre abri",
			options: options.depth.map((d)=>({
				value:d,
				display:<SchematicSVG
					w={selected_values.width0}
					h={3.1||selected_values.height}
					d={d+0.05}
					height={svgs_height}
					mode='depth'
				/>
			})),
			type: 'images',
			selected_id: 'depth',
			auto_scroll: false
		},
		{
			head: "Choisissez la hauteur de votre abri",
			options: options.height.map((h)=>({
				value:h,
				display:<SchematicSVG
					w={selected_values.width0}
					h={h}
					d={selected_values.depth}
					height={svgs_height}
					mode='height'
				/>
			})),
			type: 'images',
			selected_id: 'height',
			infos: <>
			<p>
				<b className="red">
					{(selected_values.height<CECA_OPTIONS_POSSIBILITIES_HEIGHT_THRESHOLD)&&<>Nouveau : <u>abri 20 cm + haut</u> - </>}
					Pose directe sur dalle</b> <br/>
				avec équerres et chevilles d'ancrage fournies
			</p>

			<table>
				<tbody>
					<tr>
						<td>Passage sous pannes :</td>
						<td>{(selected_values.height-0.2).toFixed(2)} m à l'avant</td>
						<td>{(selected_values.height-0.2-(selected_values.depth*0.05)).toFixed(2)} m à l'arrière</td>
					</tr>
					<tr>
						<td>Dimensions hors tout :</td>
						<td>{(selected_values.height).toFixed(2)} m à l'avant</td>
						<td>{(selected_values.height-(selected_values.depth*0.05)).toFixed(2)} m à l'arrière</td>
					</tr>
				</tbody>
			</table>
			</>
		},
		{
			head: "Choisissez votre nombre de modules",
			options: options.modules.map((m)=>({
				value:m,
				display:m+' module'+(m>1?'s':'')
			})),
			type: 'texts',
			selected_id: 'modules',
			infos: 'Pour plus de 3 modules contactez-nous.'
		},
		...['width0','width1','width2'].map((id,i)=>{
			return {
				head:(selected_values.modules>1)?<>Choisissez la largeur<small> de votre {
					[<>1<sup>er</sup></>,<>2<sup>ond</sup></>,<>3<sup>ème</sup></>][i]
				} module</small></>:<>Choisissez la largeur de votre abri</>,
				options:options[id].map((w)=>({
					value:w,
					display:<SchematicSVG
						w={w}
						h={selected_values.height}
						scale={10}
						height={40}
						mode='width'
					/>
				})),
				type:'images',
				selected_id:id,
				hidden:(i>=selected_values.modules)
			}
		}),
		...[
			['color_roof','de votre toiture']
		].map((color,i)=>{
			const color_id = color[0];
			return {
				head:<>Choisissez le coloris {color[1]}</>,
				options:options[color_id].map((c)=>({
					value: c,
					display: ralToColor(c)
				})),
				type:'colors',
				selected_id:color_id
			}
		}),
		...[
			['wall_front','long pan haut'],
			['door_front','long pan haut',true,'wall_front'],
			['wall_left','pignon gauche'],
			['wall_back','long pan bas'],
			['door_back','long pan bas',true,'wall_back'],
			['wall_right','pignon droit']
		].map((wall_or_door,i)=>{
			const id = wall_or_door[0];
			const wall = !wall_or_door[2];
			const plural = (selected_values[id]>1)?'s':'';// num. of selected doors
			return {
				head:wall?<>Choisissez un bardage <small>{wall_or_door[1]}</small></>:<>Choisissez le nombre de réservation <small>{wall_or_door[1]}</small></>,
				options:options[id].map((v)=>{
					return wall?{
						value:v,
						display:v?'Avec bardage':'Sans bardage'
					}:{
						value:v,
						display:v?<>{v} <small>{((options[id].length<4)?('réservation'+(v>1?'s':'')):'réserv.')}</small></>:'Aucune'
					};
				}),
				type:'texts',
				selected_id:id,
				infos:wall?undefined:(options[id].length===1?<p>
					Pour mettre des portes à l'avant et à l'arrière, <i>contactez-nous.</i>
				</p>:<>
					<p>Réservation{plural} avec montants métalliques renforcés, pour <b>porte{plural} 240 x 200 cm</b> disponible{plural} en magasin bricolage.</p>
					{(
						selected_values[id]>0&&
						selected_values[id]!==selected_values.modules
					)&&(<p>Pour réservation sur un module spécifique, <i>contactez-nous.</i></p>)}
					{(selected_values[id]>0)&&<p className="red"><b>Porte{plural} <u>non fournie{plural}</u> - Illustration non contractuelle.</b></p>}
				</>),
				hidden:(!wall&&!selected_values[wall_or_door[3]])||(selected_values.height>CECA_OPTIONS_POSSIBILITIES_HEIGHT_THRESHOLD&&wall_or_door[2])
			}
		}),


		{
			infos: <>
				<p>{(selected_values.wall_left || selected_values.wall_right)?"✅ Les bardages pignon des abris personnalisés Abri-Tole.fr sont fournis de série avec rive et angles ; toutefois, si souhaitez améliorer le rendu esthétique de votre abri, vous pouvez ajouter à celui-ci des accessoires de finition optionnels.":"Si souhaitez améliorer le rendu esthétique de votre abri, vous pouvez ajouter à celui-ci des accessoires de finition optionnels."}</p>
			</>,
			special_mode:'optional_accessories',
			selected_id:'optional_accessories'
		},



		...[
			['color_walls','de votre bardage'],
			['color_accessories','des accessoires']
		].map((color,i)=>{
			const color_id = color[0];
			let auto_scroll = true;
			if(has_optional_accessories){
				if(color_id === 'color_walls' && has_color_walls){
					auto_scroll = false;
				}
				if(color_id === 'color_accessories' && !has_color_walls){
					auto_scroll = false;
				}
			}
			return {
				head:<>Choisissez le coloris {color[1]}</>,
				options:options[color_id].map((c)=>({
					value: c,
					display: ralToColor(c)
				})),
				type:'colors',
				selected_id:color_id,
				auto_scroll: auto_scroll?'center':false
			}
		}),
		{
			head:<>Tôles ATG-PRO® <small>avec atténuateur de gouttage</small></>,
			options:options.atg.map((v)=>{
				return {
					value:v,
					display:v?'Oui':'Non'
				};
			}),
			type:'texts',
			selected_id:'atg',
			infos:<>
				<p>Les tôles ATG-PRO® ne sont disponibles que dans les <b className="nowrap">RAL <span>{CECA_COLORS.filter(c => c.atg).reduce(
					(accumulator,color_value,color_index,colors_array)=>{
						let new_accumulator = accumulator+color_value.ral;
						const distance_from_end = colors_array.length - color_index - 1;
						if(distance_from_end === 1){
							new_accumulator += ' et ';
						}else if(distance_from_end >= 1){
							new_accumulator += ', ';
						}
						return new_accumulator;
					},
					''
				)}</span></b>.</p>
				<p>Elles sont livrées avec l'hydrofuge <i>iso-Fibre®</i> à appliquer en bas de pente pour éviter l'épargne ou le brûlage du revêtement.</p>
				<p><a href="https://tole-atg-pro.com/" target="_blank" rel="noreferrer">Pour plus d'informations sur les tôles ATG-PRO® <u>cliquez ici</u>.</a></p>
			</>
		},
		{
			head:<>1 pince <small>pour réalisation de larmiers</small></>,
			options:options.atg_device.map((v)=>{
				return {
					value:v,
					display:v?'Oui':'Non'
				};
			}),
			type:'texts',
			selected_id:'atg_device',
			infos: <div className="atg-device">
				<p>Cet outil permet de réaliser des larmiers en bas de pente afin d'assurer une efficacité maximale du régulateur de condensation de vos tôles <i>ATG-PRO®</i>.</p>
				<p><a href="https://tole-atg-pro.com/#ipose" target="_blank" rel="noreferrer">Pour plus d'informations <u>cliquez ici</u>.</a></p>
			</div>,
			hidden:(!selected_values['atg'])
		},
		{
			head:<>{selected_values.modules*2} puits de lumière <small>en couverture</small></>,
			options:options.transparent.map((v)=>{
				return {
					value:v,
					display:v?'Oui':'Non'
				};
			}),
			infos: <>
				<p>Apportez de la lumière naturelle dans <i>votre abri.</i></p>
				<p>⚠️ Zone générant de la condensation comme une tôle classique.</p>
			</>,
			type:'texts',
			selected_id:'transparent'
		},


		{
			head:'Livraison et déchargement',
			options:options.delivery.map((v)=>{
				return {
					value:v,
					display:v?'Oui » INCLUS':'Non'
				};
			}),
			type:'texts',
			selected_id:'delivery',
			infos:<>
				<p>⚠️ Livraison en zone montagneuse et/ou hors France continentale, un surcout peut être appliqué en cas de contraintes d'accès du camion ou du chariot de déchargement.</p>
				<p>La livraison comporte systématiquement le déchargement.</p>
				{!IFRAME_MODE&&<p><a href="#video-livraison">Pour voir une vidéo du déchargement <u>cliquez ici</u>.</a></p>}
			</>,
			hidden:false
		},
		{
			head:"Demandez votre devis",
			options:[{value:true,display:<>Demande de devis <u>cliquez ici</u></>}],
			type:'buttons',
			selected_id:'ask',
			hidden:!!hideAsk,
			auto_scroll: hideAsk?false:'nearest'
		}
	];

	let selector_number = 1;
	let last_selector_id_selected = false;
	let stop_last_selector_id_selected = false;
	selectors.forEach((selector, i) => {
		if(typeof selector.hidden === 'undefined' && !selector.special_mode){
			//hide selectors without choice
			selector.hidden = (selector.options.length <= 1);
		}
		if(typeof selector.auto_scroll === 'undefined'){
			//hide selectors without choice
			selector.auto_scroll = 'center';
		}
		if(selected_values.hasOwnProperty(selector.selected_id)){
			selector.selected_value = selected_values[selector.selected_id];
		}
		if(!selector.hidden){
			selector.number=selector_number;
			selector_number++;
		}

		if(!stop_last_selector_id_selected && !selector.hidden){
			if(setted_steps[selector.selected_id]||(
				selector.type!=='buttons'&&
				selector.options&&
				selector.options.length<2
			)){
				last_selector_id_selected = selector.selected_id;
			}else{
				stop_last_selector_id_selected = true;
			}
		}
	});

	let focus_status_to_set = last_selector_id_selected?'past':'present';
	selectors.forEach((selector, i) => {
		if(!selector.hidden){
			selector.focus_status = focus_status_to_set;
			if(focus_status_to_set === 'present'){
				focus_status_to_set = 'future';
				if(active_step !== selector.selected_id){
					setActiveStep(selector.selected_id);
				}
			}
			if(selector.selected_id === last_selector_id_selected){
				focus_status_to_set = 'present';
			}
		}else{
			selector.focus_status = 'future';
		}
	});






	return (
		<EditorStyled ref={container_ref}>
			<h2>Personnalisez votre abri</h2>
			<div className={'selectors-holder'}>
				{selectors.map((selector,id)=>{
					if(selector.hidden){
						return false;
					}
					if(selector.special_mode){
						return <Selector
							key={id}
							head_number={selector.number}
							selected_id={selector.selected_id}
							focus_status={selector.focus_status}
							onSelection={onSelection}
							auto_scroll={selector.auto_scroll}

							special_mode={selector.special_mode}
							special_mode_selected_values={selected_values}
						/>;
					}
					return <Selector
						key={id}
						head_number={selector.number}
						head_text={selector.head}
						options={selector.options}
						type={selector.type}
						infos={selector.infos}
						selected_id={selector.selected_id}
						selected_value={selector.selected_value}
						focus_status={selector.focus_status}
						onSelection={onSelection}
						auto_scroll={selector.auto_scroll}
					/>;
				})}
			</div>
			<Scrolldown/>
		</EditorStyled>
	);
}

export default Editor;
